<template>
    <section class="panel panel--content panel--grid-content panel--white panel--list">
        <div id="vue-guides-list" class="panel__body">
            <div class="content content--main guide-browse">
                <div class="guide-browse--pages">
                    <h2 v-if="title">{{ title }}</h2>
                    <div class="filter">
                        <div v-if="search_filter == 1" class="filter__input">
                            <div class="filter__box">
                                <input type="text" placeholder="Search content" aria-controls="guide-pages" class="form-control" v-model="search" v-debounce:600ms="search_list">
                            </div>
                        </div>
                        <div v-if="tags_filter == 1" class="filter__select">
                            <select aria-label="filter by topic" class="custom-select form-control" v-model="selected_tag">
                                <option v-for="tag in tags_array" :value="tag" :key="tag">
                                    {{ tag }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <ul v-if="list_data" id="guide-pages">
                        <li v-for="link in list_data" :key="link" class="guide-browse__item">
                            <a :href="link.url" class="guide-browse__link">
                                <h3 class="guide-browse__title u-chevron">{{ link.title }}</h3>
                                <span class="guide-browse__description">{{ link.description }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import mixins from '../mixins.js'

export default {
    props: {
        panel_number: Number,
        title: String,
        search_filter: Number,
        tags_filter: Number,
        links: Array
    },
    mixins: [ mixins ],
    data() {
        return {
            list_data: null,
            tags_array: [],
            search: '',
            selected_tag: 'All tags',
            filtering: false
        }
    },
    watch: {
        selected_tag() {
            // Clear the search field
            this.search = '';
            // See if a value has been selected
            if(this.selected_tag !== 'All tags') {
                this.filter_by_tag();
            } else {
                this.list_data = this.links;
            }
        }
    },
    methods: {
        filter_by_tag() {
            this.filtering = true;

            // Load the tag into a local variable
            let tag = this.selected_tag;
            // Load the original list data into a local variable
            let list_data_fresh = this.links;
            
            // Function to filter by the tags into each list item
            function filterByTag(item) {
                if(item.tags.includes(tag)) {
                    return true
                } 
                return false;
            }
            this.list_data = list_data_fresh.filter(filterByTag);
            
            this.filtering = false;
        },
        search_list() {
            this.filtering = true;

            if(this.selected_tag !== 'All tags') {
                this.filter_by_tag();
            } else {
                this.list_data = this.links;
            }
            let tmp = this.list_data;

            var results = [];

            this.search = this.trim_string(this.search);
            let search_term = this.search.toLowerCase();

            if(this.search.length > 0){
                for(var i = 0; i < this.list_data.length; i++) {
                    for(var key in this.list_data[i]) {
                        let value = this.list_data[i][key];
                        // Need to loop through the keys rather than specifying them
                        if(typeof value === 'string') {
                            if(value.toLowerCase().indexOf(search_term) !== -1) {
                                if(!this.item_exists(results, this.list_data[i])) {
                                    results.push(this.list_data[i])
                                }
                            } 
                        }
                    }
                }
                this.list_data = results;
            } else {
                this.list_data = tmp;
            }

            this.filtering = false;
        }
    },
    created() {
        this.list_data = this.links;

        // If the tag filter is set to TRUE
        if(this.tags_filter == 1) {
            // Loop through all of the links
            for(var i = 0; i < this.list_data.length; i++){
                // Then loop through the tags, if any, for that link
                for(var j = 0; j < this.list_data[i]['tags'].length; j++){
                    // Now check to see if it is already in the array, and if not add it
                    if(!this.tags_array.includes(this.list_data[i]['tags'][j])){
                        this.tags_array.push(this.list_data[i]['tags'][j]);
                    }
                }
            }
            // Sort the objects
            this.tags_array.sort();
            // Now add in our generic All list item
            this.tags_array.splice(0, 0, 'All tags'); 
        }
    },
    beforeDestroy() {
        localStorage.removeItem('listArray-' + this.panel_number);
    }
}
</script>
